/**
 * @ INTERNAL DEPENDENCIES
 */
import { createAction } from 'redux-actions';
import * as authApi from '../../api/auth';
import * as api from '../../api';
import _ from 'lodash';
import {setStoreIdHeader} from "../../api";

/**
 * @ ACTION CREATORS
 */
export const setUser = createAction('APP_SET_USER');
export const setIsSessionTimeout = createAction('APP_SET_IS_SESSION_TIMEOUT');
export const setIsAuthenticated = createAction('APP_SET_IS_AUTHENTICATED');
export const setForceAccountMaintMode = createAction('APP_SET_FORCE_ACCOUNT_MAINT_MODE');
export const setErrorOverlay = createAction('APP_SET_ERROR_OVERLAY');
export const scrollToTop = createAction('APP_SCROLL_TO_TOP');
export const setActiveStore = createAction('APP_SET_ACTIVE_STORE');
export const clearErrorOverlay = () => dispatch => {
  dispatch(setErrorOverlay(null))
}
export const setIsNotAuthenticated = createAction(
  'APP_SET_IS_NOT_AUTHENTICATED'
);
export const _setStores = createAction('APP_SET_STORES');
export const _updateActiveStoreData = createAction('APP_SET_CURRENT_STORE_DATA')

export const getStores = () => dispatch => {
  api.getStores().then(storeRes => {
    const storeData = storeRes.data.locations;
    if(!storeData || storeData.length === 0){
      dispatch(setErrorOverlay({message: 'You current do not have permission to use this tool'}))
      localStorage.removeItem('auth_token')
      dispatch(setIsNotAuthenticated());
      return
    }

    dispatch(_setStores(storeData));
    let currentActiveStore = localStorage.getItem('x-store-id');
    if(currentActiveStore){
      if(!_.find(storeData, store => (store.store_id === currentActiveStore))){ // Make sure whatever's set in local storage is actually allowed for this user
        currentActiveStore = null
      }
    }
    if(!currentActiveStore){
      currentActiveStore = storeData[0].store_id;
    }
    setStoreIdHeader(currentActiveStore)
    dispatch(setActiveStore(currentActiveStore))
  });
};
export const updateStoreHours = (payload) => dispatch => {
  let currentActiveStore = localStorage.getItem('x-store-id');
  if(!currentActiveStore){
    throw Error('No Active Store set');
  }
  
  return api.updateStoreHours(currentActiveStore, payload).then(res => {
    return dispatch(_updateActiveStoreData(res.data))
  });
}


export const completeRegister = (username, password) => dispatch => {
  return authApi.completeRegister(username, password).then(res => {
    if (res.data.token) {
        api.setAuthHeader(res.data.token);
        dispatch(setUser(res.data.user));
        window.setTimeout( () => dispatch(setIsAuthenticated()), 1500);
        localStorage.setItem('loggedIn', '1');
        localStorage.setItem('auth_token', res.data.token)
        dispatch(getStores())
    }
  }).catch(error => {
    let messages = ["An unexpected error has occurred, please try again."]
    if(error.response && error.response.data){
      const responseData = error.response.data
      if(responseData){
        if (responseData.errors) {
          messages = responseData.errors
        }else if (responseData.error) {
          messages = [responseData.error]
        }
      }
    }
    localStorage.removeItem('auth_token')
    return Promise.reject(messages[0]);
  })
}
export const authenticateBasic = (username, password) => dispatch => {
  return authApi.authenticateBasic(username, password).then(res => {
    if (res.data.token) {
      if(res.data.f){
        api.setAuthHeader(res.data.token, true);
        return Promise.resolve(res.data.f)
      }else{
        api.setAuthHeader(res.data.token);
        dispatch(setUser(res.data.user));
        window.setTimeout( () => dispatch(setIsAuthenticated()), 1500);
        localStorage.setItem('loggedIn', '1');
        localStorage.setItem('auth_token', res.data.token)
        dispatch(getStores())
        return Promise.resolve(null)
      }

    }
  }).catch(error => {
    let messages = ["Your credentials seem to be incorrect, please try again"]
    if(error.response && error.response.data){
      const responseData = error.response.data
      if(responseData){
        if (responseData.errors) {
          messages = responseData.errors
        }else if (responseData.error) {
          messages = [responseData.error]
        }
      }
    }
    localStorage.removeItem('auth_token')
    return Promise.reject(messages[0]);
  })
}
// }
export const authenticate = token => dispatch => {
  api.setAuthHeader(token);
  return authApi
    .getUser()
    .then(res => {
      if (res.data.user) {
        dispatch(setIsAuthenticated())
        dispatch(setUser(res.data.user))
        // window.setTimeout( () => dispatch(setIsAuthenticated()), 1500);
        localStorage.setItem('loggedIn', '1');
        dispatch(getStores())
      } else {
        localStorage.removeItem('auth_token')
        return Promise.reject('Not authorized');
      }
    })
    .catch(error => {
      localStorage.removeItem('auth_token')
      return Promise.reject('Not authorized');
    });
};


export const logout = () => dispatch => {
  localStorage.removeItem('auth_token')
  dispatch(setIsNotAuthenticated());
};
